import { Authority } from '@project44/ui-utils';

import { IGuard } from '../types';
import {
  ANALYTICS_AUTHORITIES,
  INITIATE_AUTHORITIES,
  P44OS_AUTHORIITES,
} from './authorityGroupings';

export const analyticsAccessCheckDeprecated = ({ user }: IGuard): boolean => {
  return !!user?.authorities.some((y) =>
    ANALYTICS_AUTHORITIES.includes(y?.authority),
  );
};

export const analyticsAccessCheck = ({ user, flags }: IGuard): boolean => {
  const { analyticsNavAmi1298 } = flags ?? {};
  return (
    analyticsNavAmi1298 &&
    !!user?.authorities.some((y) =>
      ANALYTICS_AUTHORITIES.includes(y?.authority),
    )
  );
};

export const dashboardAccessCheck = ({ flags }: IGuard): boolean => {
  return !!flags?.featureExc2061;
};

export const initiateAccessCheck = ({ user }: IGuard): boolean => {
  return !!user?.authorities.some((y) =>
    INITIATE_AUTHORITIES.includes(y?.authority),
  );
};

export const initiateMarketingSectionAccessCheck = ({
  user,
}: IGuard): boolean => {
  return !initiateAccessCheck({ user });
};

export const initiateFTLMarketingAccessCheck = ({ user }: IGuard): boolean => {
  return (
    !!user?.customerProperties?.SHOW_INITIATE_MARKETING_PAGE_IN_MOVEMENT &&
    !initiateAccessCheck({ user })
  );
};
// The following are individual analytics authority checks
export const analyticsOceanAccessCheck = ({ user, flags }: IGuard): boolean => {
  const { analyticsNavAmi1298 } = flags ?? {};
  return (
    analyticsNavAmi1298 &&
    !!user?.authorities.some((y) =>
      [Authority.ANALYTICS_OCEAN].includes(y?.authority),
    )
  );
};

export const analyticsPortIntelAccessCheck = ({
  user,
  flags,
}: IGuard): boolean => {
  const { analyticsNavAmi1298 } = flags ?? {};
  return (
    analyticsNavAmi1298 &&
    !!user?.authorities.some((y) =>
      [Authority.ANALYTICS_PORT_INTEL].includes(y?.authority),
    )
  );
};

export const analyticsSustainabilityAccessCheck = ({
  user,
  flags,
}: IGuard): boolean => {
  const { analyticsNavAmi1298 } = flags ?? {};
  return (
    analyticsNavAmi1298 &&
    !!user?.authorities.some((y) =>
      [Authority.ANALYTICS_OCEAN_SUSTAINABILITY].includes(y?.authority),
    )
  );
};

export const analyticsTruckloadAccessCheck = ({
  user,
  flags,
}: IGuard): boolean => {
  const { analyticsNavAmi1298 } = flags ?? {};
  return (
    analyticsNavAmi1298 &&
    !!user?.authorities.some((y) =>
      [Authority.ANALYTICS_TRUCKLOAD].includes(y?.authority),
    )
  );
};

export const analyticsTruckloadTrackingRcaAccessCheck = ({
  user,
  flags,
}: IGuard): boolean => {
  const { networkNavConsumption } = flags ?? {};
  return (
    !networkNavConsumption &&
    (user?.tenantCarrierNetworkRoles.includes('SHIPPER') as boolean) &&
    !!user?.authorities.some((y) =>
      [Authority.ANALTYICS_ROOT_CAUSE_ANALYSIS].includes(y?.authority),
    )
  );
};

export const networkTruckloadTrackingRcaAccessCheck = ({
  user,
  flags,
}: IGuard): boolean => {
  const { networkNavConsumption } = flags ?? {};
  return (
    networkNavConsumption &&
    (user?.tenantCarrierNetworkRoles.includes('SHIPPER') as boolean) &&
    !!user?.authorities.some((y) =>
      [Authority.ANALTYICS_ROOT_CAUSE_ANALYSIS].includes(y?.authority),
    )
  );
};

export const networkLinkCheck = ({ user, flags }: IGuard): boolean => {
  const { networkNavConsumption } = flags ?? {};
  return (
    networkNavConsumption &&
    (user?.tenantCarrierNetworkRoles.includes('SHIPPER') as boolean) &&
    !!user?.authorities.some((y) =>
      [Authority.NETWORK_READ_HEALTH_DASHBOARD].includes(y?.authority),
    )
  );
};

export const networkParentLink = ({ user, flags }: IGuard): boolean => {
  const { networkNavConsumption } = flags ?? {};
  return (
    networkNavConsumption &&
    (user?.tenantCarrierNetworkRoles.includes('SHIPPER') as boolean) &&
    !!user?.authorities.some((y) =>
      [
        Authority.NETWORK_READ_HEALTH_DASHBOARD,
        Authority.ANALTYICS_ROOT_CAUSE_ANALYSIS,
      ].includes(y?.authority),
    )
  );
};

export const p44osAccessCheck = ({ user }: IGuard): boolean => {
  return !!user?.authorities.some((y) =>
    P44OS_AUTHORIITES.includes(y?.authority),
  );
};
